import { render, staticRenderFns } from "./CustomerPhoneOtp.vue?vue&type=template&id=143b3f87"
import script from "./CustomerPhoneOtp.vue?vue&type=script&lang=js"
export * from "./CustomerPhoneOtp.vue?vue&type=script&lang=js"
import style0 from "./CustomerPhoneOtp.vue?vue&type=style&index=0&id=143b3f87&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports